import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'

import screenReducer, { SCREEN_REDUCER_KEY } from './screenSlice'
import { screenMiddleware } from './screenMiddleware'
import langReducer, { LANG_REDUCER_KEY } from './langSlice'
import commonReducer, { COMMON_REDUCER_KEY } from './commonSlice'


const rootReducer = combineReducers({
    [SCREEN_REDUCER_KEY]: screenReducer,
    [LANG_REDUCER_KEY]: langReducer,
    [COMMON_REDUCER_KEY]: commonReducer,
})

const store = configureStore({
    reducer: rootReducer,
    middleware: [
        ...getDefaultMiddleware(),
        screenMiddleware,
    ],
})

export default store
